
import { Project } from 'projects/app-misc/src/app/modules/project-misc/data/project/project';
import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { ProjectStatus } from 'projects/app-misc/src/app/modules/project-misc/data/project/statuses/project-status';
import { ShortProject } from 'projects/app-misc/src/app/modules/project-misc/data/project/short-project';
import { Cabinet } from 'projects/app-misc/src/app/modules/cabinets/data/cabinet';

@JsonObject('model.Part')
export class Part extends AbstractModel {
  @JsonProperty(Number, 'cabinetId')
  cabinetId: number;

  @JsonProperty(Number, 'cabinetNumber')
  cabinetNumber: number;

  @JsonProperty(Cabinet, 'cabinet')
  cabinet?: Cabinet;

  @JsonProperty(String, 'cabinetName')
  cabinetName: string;

  @JsonProperty(Number, 'cnt')
  cnt: number;

  @JsonProperty(String, 'description')
  description: string;

  @JsonProperty(String, 'widthFraction')
  widthFraction: string;

  @JsonProperty(String, 'lengthFraction')
  lengthFraction: string;

  @JsonProperty(Number, 'id')
  id: number;

  @JsonProperty(Boolean, 'createdManually')
  createdManually?: boolean;

  @JsonProperty(Boolean, 'finishingReady')
  finishingReady?: boolean;

  @JsonProperty(String, 'colorNote')
  colorNote: string;

  @JsonProperty(Number, 'width')
  width?: number;

  @JsonProperty(Number, 'length')
  length?: number;

  finishingGroupId: number;
}
